// [readme.md содержит более полное описание проекта]
// paylate - базовый Тип Виджета, его компоненты находятся в ./src/components
// при создании новых Типов Виджета ориентируемся на структуру paylate
// для остальных плагинов компоненты располагаются в их папках ./src/plugins/{widgetType}

import Vue from 'vue';
import VueMask from 'v-mask';
Vue.config.productionTip = false;

window.addEventListener(
    'sessionready',
    (e) => (widget.juicySession = e.detail.sessionId),
    false
);

import fakeIncomingData from "@/helpers/incomingData.json";

// Добавляем плагины типов виджета
// import paylate from './plugins/paylate_new/install.js';
// import bnpl from './plugins/bnpl/install.js';
// import siab from './plugins/siab/install.js';
// import cityads from './plugins/cityads/install.js';
// import smsfinans from './plugins/smsfinans/install.js';
import zaymer from './plugins/zaymer/install.js';

const types = {
    // paylate,
    // bnpl,
    // siab,
    // cityads,
    // smsfinans,
    zaymer
};

// Меняем название виджета для отображения
// let widget = getWidget( types['paylate']  );
// let widget = getWidget( cityads  );
let widget = getWidget( zaymer );

function getWidget( widgetType = types['paylate'] ) {
    Vue.use(VueMask);
    Vue.use(widgetType.install);

    Vue.mixin({
        computed: {
            // объект получаемый от l-kredit.js
            $CLObject() {
                return this.$root.CLObject;
            },
            // базовые сущности виджета (подключаем миксины в install.js плагина)
            $anketa() {
                return this.$root.anketa;
            }, 
            $forms() {
                return this.$root.forms;
            },
            $modals() {
                return this.$root.modals;
            },
            $connector() {
                return this.$root.connector;
            },
            ////
            $isDebug() {
                return this.$root.debug;
            },
            $isMobile() {
                return this.$root.windowWidth <= 428;
            },
        }
    });

    return new Vue({
        vuetify: widgetType.vuetify,
        mixins: widgetType.mixins,
        mounted() {
            // incomingData объявлен в index.html
            process.env.NODE_ENV == "production"
                ? this.CLObject = incomingData
                : this.CLObject = fakeIncomingData
            
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
                this.windowHeight = window.innerHeight;
            });

            top.postMessage({event_id: 'resize_modal'},'*');

            // [TEST] //
            if (!this.$isDebug) return;
            // console.log('md5', MD5('azaza').toString())
            // Переход на другой плагин
            // setTimeout( () => widget.rebuildWidget(), 5000 );
        },
        data() {
            return {
                CLObject: {},

                debug: process.env.NODE_ENV != 'production',
                juicySession: '',  
                
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight,
            };
        },
        methods: {
            rebuildWidget( type = 'paylate' ) {
                widget = getWidget( types[type] );
            },
        },
        render: h => h(widgetType.App),
    }).$mount('#app');
}

